angular.module('zc.zenclerkS')
  .component('zcsAgencyProjectTable', {
    templateUrl: '/templates/zenclerk_s/agencies/sites/agency_project_table.html',
    bindings: {
      projects: '<',
      projectsMaxInvoice: '<'
    },
    controller: zcsAgencyProjectTable,
  });

zcsAgencyProjectTable.$inject = ['$scope', '$stateParams', '$translate', 'CampaignStatsV2', 'Devise', 'ZcsProject'];
function zcsAgencyProjectTable($scope, $stateParams, $translate, CampaignStatsV2, Devise, ZcsProject) {
  const vm = this;
  vm.sortProp = 'conversion_tag_confirmed_at';

  vm.setSortProp = setSortProp;
  vm.removeProject = removeProject;
  vm.guessProjectStatus = guessProjectStatus;
  vm.getTerminatedDate = getTerminatedDate;

  vm.data = [
    'apikey',
    'title',
    'company_name',
    'shopping_cart_asp',
    'cart_id',
    'base_url',
    'created_at',
    'project_status',
    'terminated_at',
    'planned_campaigns',
    'started_campaigns_count',
    'days_since_last_campaign',
    'max_invoice',
  ];
  vm.header = [
    'APIKEY',
    $translate.instant('agencies.sites.projectTableComponent.saito_na'),
    $translate.instant('agencies.sites.projectTableComponent.kaishamei'),
    $translate.instant('agencies.sites.projectTableComponent.kaato_asp'),
    $translate.instant('agencies.sites.projectTableComponent.kaato_id'),
    $translate.instant('agencies.sites.projectTableComponent.saito'),
    $translate.instant('agencies.sites.projectTableComponent.saito_sakusei_hi'),
    $translate.instant('agencies.sites.projectTableComponent.dounyuu_suteetasu'),
    $translate.instant('agencies.sites.projectTableComponent.keiyaku_shuuryoubi'),
    $translate.instant('agencies.sites.projectTableComponent.haishin_kazu_nakaguro'),
    $translate.instant('agencies.sites.projectTableComponent.kyanpeen_sousuu'),
    $translate.instant('agencies.sites.projectTableComponent.saigo_no_kyanpeenkara'),
    $translate.instant('agencies.sites.projectTableComponent.seikyuu_jougen_kingaku'),
  ];

  vm.getCSV = getCSV;

  vm.$onChanges = () => {
    vm.filteredProjects = filterProjects();
    _.each(vm.projects, project => {
      // Get maximum invoice - falsey means "show spinner", -1 means "not to show""
      if(project.terminated_at || project.is_demo || project.is_test) {
        project.max_invoice = -1;
      } else {
        project.max_invoice = vm.projectsMaxInvoice[project.apikey];
      }

      const elapsedDays = [];
      project.planned_campaigns = 0;
      project.days_since_last_campaign = 0;
      project.started_campaigns_count = project.started_campaigns.length;
      project.has_widget = false;
      project.project_status = vm.guessProjectStatus(project);

      if(project.started_campaigns.length === 0) {
        project.days_since_last_campaign = -1;
      } else {

        _.each(project.started_campaigns, campaign => {
          if(campaign.is_widget) {
            if(campaign.status === 'activated') {
              // TODO: not used currently (yet), but just to avoid counting widget
              project.has_widget = true;
            }
          } else if(campaign.status === 'activated' && moment(campaign.end_at).isAfter(moment())) {
            project.planned_campaigns += 1;
          } else if(campaign.status === 'blocked' || campaign.status === 'terminated') {
            project.has_terminated_campaigns = true;
          } else if(campaign.status === 'activated') {
            elapsedDays.push(moment().diff(moment(campaign.end_at), 'days'));
          }
        });

        if(elapsedDays.length === 0) {
          project.days_since_last_campaign = -1;
        }

        // If blocked or terminated exists, check when it was last delivered
        if(!project.has_terminated_campaigns && project.planned_campaigns > 0) {
          // take the lowest value
          project.days_since_last_campaign = _.min(elapsedDays);
        } else {
          // take lastest campaign stats and only after that take the lowest value
          CampaignStatsV2.find({
            dimension: 'hourly',
            apikey: project.apikey,
          }, {
            delivery_count: { $gte: 1 }
          }, {
            sort: { start_at: -1 },
            limit: 1
          }).then(stats => {
            // if does not have any, it means no campaign has ever been delivered
            if(stats.length > 0) {
              elapsedDays.push(moment().diff(moment(stats[0].start_at), 'days'));
            }
            project.days_since_last_campaign = _.min(elapsedDays) || 0;
          });
        }
      }
    });
  };

  function filterProjects() {
    const projects = _.chain(vm.projects)
      .filter(p => p.product_line === 'zenclerk_s')
      .sortBy(p => {
        // Dates are strings so must do new Date creation or safari sorting does not work
        if(vm.sortProp.endsWith('_at')) {
          return -new Date(p[vm.sortProp]);
        }
        return -_.get(p, vm.sortProp);
      })
      .value();

    return projects;

  }

  function removeProject(project) {
    Devise.getCurrentUser()
      .then(user => {
        ZcsProject.remove(user.id, project.apikey)
          .then(() => {
            vm.projects = _.reject(vm.projects, i => i.apikey === project.apikey);
            vm.filteredProjects = filterProjects();
          });
      });
  }

  function setSortProp(prop) {
    vm.sortProp = prop;
    vm.filteredProjects = filterProjects();
  }

  function getTerminatedDate(date) {
    return moment(date).subtract(1, 'month').format('YYYY-MM');
  }

  function guessProjectStatus(project) {
    if(project.terminated_at) {
      return 'terminated';
    }
    if(project.suspended_at) {
      return 'suspended';
    }
    if(project.conversion_tag_confirmed_at) {
      return 'conversion_tag_confirmed';
    }
    return 'no_tag_set';
  }

  function getCSV() {
    let csvData = _.map(vm.projects, p => _.pick(p, vm.data));
    return csvData;
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/agencies/sites/agency_project_table.component.js